import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectContent } from '@components/SelectContentModal';
import { selectContentAlerts } from '@redux/contentMessages/selectors';
import { selectNonVideoDocuments } from '@redux/documents/reducers';
import { selectContentForms } from '@redux/forms/reducers';
import { selectContentMessages } from '@redux/contentMessages/selectors';
import { selectContentQuestionnaires } from '@redux/forms/reducers';
import { selectContentReminders } from '@redux/contentMessages/selectors';
import { selectContentTasks } from '@redux/forms/reducers';
import { selectVideoDocuments } from '@redux/documents/reducers';
import { selectWeblinks } from '@redux/weblinks/selectors';
import { fetchDocuments } from '@redux/documents/actions';
import { fetchContentMessages } from '@redux/contentMessages/actions';
import { fetchForms } from '@redux/forms/actions';
import { fetchWeblinks } from '@redux/weblinks/actions';

export const useAllContent = () => {
  const dispatch = useDispatch();
  const [alertsLoading, alerts] = useSelector(selectContentAlerts);
  const [documentsLoading, documents] = useSelector(selectNonVideoDocuments);
  const [formsLoading, forms] = useSelector(selectContentForms);
  const [messagesLoading, messages] = useSelector(selectContentMessages);
  const [questionnairesLoading, questionnaires] = useSelector(selectContentQuestionnaires);
  const [remindersLoading, reminders] = useSelector(selectContentReminders);
  const [tasksLoading, tasks] = useSelector(selectContentTasks);
  const [videosLoading, videos] = useSelector(selectVideoDocuments);
  const [weblinksLoading, weblinks] = useSelector(selectWeblinks);
  const [stateContentLoading, stateContent] = useSelector(selectContent);
  const allContent = useMemo(
    () => [
      ...alerts,
      ...documents,
      ...forms,
      ...messages,
      ...questionnaires,
      ...reminders,
      ...tasks,
      ...videos,
      ...weblinks,
      ...stateContent,
    ],
    [
      alerts,
      documents,
      forms,
      messages,
      questionnaires,
      reminders,
      tasks,
      videos,
      weblinks,
      stateContent,
    ],
  );
  const contentLoading =
    alertsLoading ||
    documentsLoading ||
    formsLoading ||
    messagesLoading ||
    questionnairesLoading ||
    remindersLoading ||
    tasksLoading ||
    videosLoading ||
    weblinksLoading ||
    stateContentLoading;

  useEffect(() => {
    dispatch(fetchDocuments());
    dispatch(fetchContentMessages());
    dispatch(fetchForms());
    dispatch(fetchWeblinks());
  }, [dispatch]);

  return [contentLoading, allContent];
};

export default useAllContent;
